<template>
  <div
    class="challenge"
    :class="{solved: solved, locked: challenge.status > 0, outsidelist: outsidelist}"
    :title="tooltip"
    :tabindex="challenge.status || outsidelist ? -1 : 0"
    @keydown.enter="openModal()"
  >
    <!-- Nobody has solved it yet: a portal, like the hardest challenges on the wargame. -->
    <div v-if="unsolvedByAll" class="portal-aura">
      <PortalParticles spawn="edge" />
    </div>
    <div @click="openModal()">
      <span class="title">{{ challenge.status === 2 ? "???" : challenge.title }}</span>
      <ul class="categories">
        <li v-for="category in challenge.categories" :key="category">
          {{ category }}
        </li>
      </ul>
      <span class="solves" :title="`This challenge has been sloved by ${challenge.solves} teams`">{{ challenge.solves }}</span>
      <span class="score" :title="`This challenge gives ${$store.getters.challScore(challenge.id)} points to each team that solves it`">{{ $store.getters.challScore(challenge.id) }}</span>
    </div>
  </div>
</template>

<script>
import PortalParticles from '@/components/PortalParticles.vue'
import router from '@/router.js'

export default {
    components: {
        PortalParticles,
    },
    props: ['challenge', 'outsidelist'],
    computed: {
        unsolvedByAll () {
            return this.challenge.status !== 2 && this.challenge.solves === 0
        },
        solved () {
            return this.$store.state.team && this.challenge.id in this.$store.state.team.solves
        },
        tooltip () {
            switch (this.challenge.status) {
            case 1:
                return 'This challenge is locked. Solve the previous challenge to unlock it.'
            case 2:
                return 'This challenge has not been published yet. It will be published at some point during the competition.'
            default:
                return ''
            }
        },
    },
    methods: {
        openModal () {
            if (this.challenge.status) return
            if (this.outsidelist) return
            router.push({ name: 'challenge', params: { id: this.challenge.id } })
        },
    },
}
</script>

<style lang="scss" scoped>
// A Minecraft tooltip; solved ones get a green frame.
.challenge {
    @include mc-tooltip;
    height: $challenge-height;
    min-width: $challenge-min-width;
    margin: calc(#{$challenge-spacing} / 2) $challenge-spacing calc(#{$challenge-spacing} / 2) 0;
    padding: 0.7rem;
    flex-wrap: wrap;
    color: $font-challenge-color;
    position: relative;
    cursor: pointer;

    // Hovered inventory slots get a white wash.
    &::before {
        content: "";
        position: absolute;
        inset: 0;
        pointer-events: none;
        background: #ffffff;
        opacity: 0;
    }

    &:hover::before {
        opacity: 0.06;
    }

    &:hover .title {
        animation: ssm-jitter 0.25s steps(1, end);
    }

    > div:not(.portal-aura) {
        position: relative;
        height: 100%;
        width: 100%;
    }
}
.title {
    font-size: 1.125rem;
    line-height: 1.3;
}
.solves {
    position: absolute;
    bottom: 0;
    left: 0;
    color: $ssm-muted;
    font-size: 0.875rem;

    &::after {
        content: " solves";
    }
}
.score {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 2.25rem;
    line-height: 1;
    color: $ssm-teal;
}
.categories {
    list-style: none;
    margin: 0.25rem 0 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;

    li {
        background-color: $ssm-secondary;
        border: $mc-px solid rgba(0, 0, 0, 0.5);
        padding: 0 0.3rem;
        font-size: 0.75rem;
    }
}

.solved {
    @include mc-frame($ssm-green);
    background-color: rgba(mix($ssm-green, #000000, 16%), 0.94);

    .score {
        color: $ssm-green;
    }
}

.locked {
    cursor: default;
    color: #8a8199;
    filter: saturate(0.4);

    .score {
        color: #8a8199;
    }

    &:hover::before {
        opacity: 0;
    }
}

.outsidelist {
    cursor: default;
}
</style>
